import { PromptDataWithId } from "./PromptDataWithId";

export class OpenAIResponse<T> {
    messages: PromptDataWithId[] = [];
    data: T;

    constructor(data: T, messages?: PromptDataWithId[]) {
        if (messages) this.messages = messages;
        this.data = data;
    }
}
